import { useAppSelector } from '@app/hooks';
import { RootState } from '@app/store';
import { TrendLines } from '@features/settings/types';
import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useCallback, useMemo } from 'react';
import { RIOT_BLUE } from 'theme';

type Props = {
  initial: TrendLines;
  onChange: (t: TrendLines) => void;
}

const ChartTrendLines = ({ initial, onChange }: Props) => {
  const userTenant = useAppSelector((state: RootState) => state.userTenant);
  const tenant = useAppSelector((state: RootState) => state.tenant);

  const currentTenant = useMemo(() => tenant.currentTenant || userTenant, [tenant.currentTenant, userTenant]);
  const themeColor = useMemo(() => currentTenant?.builder_color || RIOT_BLUE, [currentTenant?.builder_color]);

  const handleChange = useCallback((e: SelectChangeEvent<TrendLines>) => {
    onChange(e.target.value as TrendLines);
  }, [onChange]);

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <Select
        value={initial}
        onChange={handleChange}
        sx={{
          '&:focus': {
            border: `1px solid ${themeColor}`,
          }
        }}
      >
        {
          Object.values(TrendLines)
            .map((t, idx) => <MenuItem value={t} key={`trendline-option-${idx}`}>{t}</MenuItem>)
        }
      </Select>
    </FormControl>
  );
}

export default ChartTrendLines;
